import type { ReactNode } from 'react';
import { useTranslations } from 'next-intl';
import { Link } from '@mentimeter/ragnar-ui/link';
import { Meta } from '@mentimeter/ragnar-ui/typography';

export function TermsOfUse() {
  const t = useTranslations('onboarding.join_workspace');
  return (
    <Meta mt={3}>{t.rich('verify_email_terms_message', { termsLink })}</Meta>
  );
}

function termsLink(chunks: ReactNode) {
  return (
    <Link href="/terms" target="_blank" rel="noopener noreferrer">
      {chunks}
    </Link>
  );
}
